import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { issueRegistersApi, templateApi } from '../services/api';
import { RegisterManagementPage } from './RegisterManagementPage';
import type { Template } from '../types/models';

export const IssueRegistersPage: React.FC = () => {
  // Fetch templates dynamically from the API
  const { data: templatesData } = useQuery({
    queryKey: ['templates', 'issue'],
    queryFn: () => templateApi.list('issue'),
  });

  // Convert templates to dropdown options (only show active templates)
  const templates = templatesData
    ?.filter((t: Template) => t.isActive)
    .map((t: Template) => ({
      value: t.templateName,
      label: t.displayName,
    })) || [];

  // Determine default template (first active template, or fallback)
  const defaultTemplate = templates.length > 0 ? templates[0].value : 'standard';

  return (
    <RegisterManagementPage
      title="Issue Registers"
      iconClass="ri-folder-line"
      queryKey="issueRegisters"
      api={issueRegistersApi}
      includeDepartments
      templates={templates}
      defaultTemplate={defaultTemplate}
      listPath="/issues"
      configPath="/issue-config"
      applyTemplateKind="issue"
      countField="issueCount"
      countLabel="Issues"
      allowForceDelete
    />
  );
};
